import styled from 'styled-components';
import Text from 'components/Text';
import PropTypes from 'prop-types';
import sp from 'styled-props';
import theme from 'utils/styles/theme';

const variants = {
	bold: `font-weight: ${theme.fontWeights.bold}`
};

const Li = styled(Text).attrs({
	as: 'li'
})`
	list-style: none;
	${sp(variants)};
`;

Li.defaultProps = {};

export default Li;
